// libs
import { useMemo } from "react";
import { Some, Option } from "@swiggy-private/js-fp";

import { useMountedRef, useEffectOnce, captureError } from "@swiggy-private/core-ui";
import { User } from "@checkout-core/interfaces/User";
import { getUserInfo } from "@checkout-core/helpers/UserHelper";
import { useSessionStorage } from "./UseSessionStorage";

export const useUserInfo = (): [Option<User>, (user: User) => void] => {
    const isMountedRef = useMountedRef();
    const [user, setUser] = useSessionStorage<User | null>("user_info", null);
    const userOption = useMemo(() => Some(user), [user]);

    useEffectOnce(() => {
        if (userOption.isSome()) {
            return;
        }

        getUserInfo()
            .then((data) => isMountedRef.current && data.isSome() && setUser(data.unwrap()))
            .catch(captureError);
    });

    return [userOption, setUser];
};
